import api from '@/api'

class PostAPI {
  async submitPost(post) {
    try {
      let resp = await api.request('POST', '/api/v1/posts', true, post)
      if (resp.status === 201) {
        return {
          success: true,
          data: resp.data
        }
      }
      return {
        success: false
      }
    } catch (error) {
      return {
        success: false,
        message: error
      }
    }
  }

  async getGroupedPosts(queries) {
    try {
      let queriesParams = new URLSearchParams(queries).toString()
      let resp = await api.request('GET', '/api/v1/posts/grouped?' + queriesParams, true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async getPost(queries) {
    try {
      let queriesParams = new URLSearchParams(queries).toString()
      let resp = await api.request('GET', '/api/v1/posts?' + queriesParams, true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async getLastSevenDaysPosts(queries) {
    try {
      let queriesParams = new URLSearchParams(queries).toString()
      let resp = await api.request('GET', '/api/v1/posts/last-seven-days/calendar?' + queriesParams, true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async editPost(postId, post) {
    try {
      let resp = await api.request('PATCH', '/api/v1/posts/' + postId, true, post)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async publishPost(postId, url, payoutSubmitted = null) {
    try {
      let resp = await api.request('PATCH', '/api/v1/posts/' + postId + '/live', true, {
        url,
        payoutSubmitted
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async updatePostForPayout(postId, data) {
    try {
      let resp = await api.request('PATCH', '/api/v1/posts/' + postId + '/payout', true, {
        data
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async completePost(postId) {
    try {
      let resp = await api.request('PATCH', '/api/v1/posts/' + postId + '/complete', true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async updateUrlPost(postId, url) {
    try {
      let resp = await api.request('PATCH', '/api/v1/posts/' + postId + '/post-url', true, {
        url
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async deletePost(postId) {
    try {
      let resp = await api.request('DELETE', '/api/v1/posts/' + postId, true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async approvePost(postID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/cs/accept/draft', true, {
        ids: postID
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in approvingPost')
    } catch (error) {
      throw error
    }
  }

  async abuseResolvePost(postID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/cs/abuse/resolved', true, {
        ids: postID
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in abuse resolving post')
    } catch (error) {
      throw error
    }
  }

  async releaseAbuseResolvePost(postID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/release/abuse/resolved', true, {
        ids: postID
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in releasing post')
    } catch (error) {
      throw error
    }
  }

  async releasePost(postID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/release/draft', true, {
        ids: postID
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in releasing Post')
    } catch (error) {
      throw error
    }
  }

  async clientApprovePost(body) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/client/accepted', true, {
        data: body
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in approvingPost')
    } catch (error) {
      throw error
    }
  }

  async clientReportPost(postID, body) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/' + postID + '/client/report', true, body)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in approvingPost')
    } catch (error) {
      throw error
    }
  }

  async bulkDeletePosts(postID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/bulk-delete/posts', true, {
        ids: postID
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in deleting Posts')
    } catch (error) {
      throw error
    }
  }

  async getPostById(postID) {
    try {
      let resp = await api.request('get', '/api/v1/posts/' + postID, true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in getting post')
    } catch (error) {
      throw error
    }
  }

  async getPostsByCampaign(campaignID) {
    try {
      let resp = await api.request('get', '/api/v1/posts/' + campaignID + '/all', true)
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in getting post')
    } catch (error) {
      throw error
    }
  }

  async getPostsByInfluencers(influencers) {
    try {
      let resp = await api.request('post', '/api/v1/posts/by/influencers', true, {influencers})
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in getting Posts')
    } catch (error) {
      throw error
    }
  }

  async csComment(postID, comment) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/' + postID + '/cs/comment', true, {
        comment
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async clientComment(postID, comment) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/' + postID + '/client/comment', true, {
        comment
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async csAssignCampaign(postID, campaignID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/' + postID + '/cs/assign/campaign', true, {
        campaignID
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong')
    } catch (error) {
      throw error
    }
  }

  async setAsMainPost(postID) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/set-main/' + postID, true)
      if (resp.status === 200) {
        return resp
      }
      throw new Error('Something went wrong in setting as primary post')
    } catch (error) {
      throw error
    }
  }

  async mapInfluencerToPost(postID, mapInfluencerObj) {
    try {
      let resp = await api.request('patch', '/api/v1/posts/' + postID + '/mapInfluencer', true, {
        mapInfluencerObj
      })
      if (resp.status === 200) {
        return resp.data
      }
      throw new Error('Something went wrong in mapping Influencer')
    } catch (error) {
      throw error
    }
  }

  changeStatus(postID, updateStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/posts/' + postID + '/changeStatus/' + updateStatus, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }

  changeBulkStatus(postIds, updateStatus) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/posts/changeBulkStatus/' + updateStatus, true, {
          ids: postIds
        })
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }

  async getS3Object(param) {
    try {
      const url = '/api/v1/posts/s3/getObject'
      let data = {
        filename: param
      }
      // console.log('file', data)
      let response = await api.request('post', url, true, data)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  async sendSubmissionGuide(param) {
    try {
      const url = '/api/v1/posts/sendgrid/dynamic/email'
      let data = param
      // console.log('Param data', data)
      let response = await api.request('post', url, true, data)

      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  async getStatusReportData(options) {
    const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('&')
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/posts/co-creating/status-report?${params}`
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }

  async updatePostByIds(data) {
    try {
      let response = await api.request('patch', `/api/v1/posts/update-by/ids`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async updatePostViewUser(data) {
    try {
      let response = await api.request('patch', `/api/v1/posts/update/view`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async updatePostOwner(data) {
    try {
      let response = await api.request('patch', `/api/v1/posts/update/owner`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async sendProposeDateClientEmail(data) {
    try {
      let response = await api.request('post', `/api/v1/posts/send/propose-date`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async sendReviseDateEmail(data) {
    try {
      let response = await api.request('post', `/api/v1/posts/send/revise-date`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async sendProposeDateAcceptedToClient(data) {
    try {
      let response = await api.request('post', `/api/v1/posts/send/propose-date/accepted`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async sendConfirmLiveDateEmailCO(data) {
    try {
      let response = await api.request('post', `/api/v1/posts/send/live-date/confirmation`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  async sendClientAcceptPost(data) {
    try {
      let response = await api.request('post', `/api/v1/posts/send/client-accepted/post`, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default new PostAPI()



// WEBPACK FOOTER //
// ./src/components/views/Post/postApi.js